module.exports = __webpack_public_path__ + "static/media/fg-left-palm.4b03d558.svg";